(function ($) {
    // Google map
    $.fn.googleMapModule = function () {

        let $modalId = $('#partnerBioData');
        const markers_list = [];
        let markerIcon = {
            path: 'M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0',
            fillColor: '#D17466',
            fillOpacity: 0.8,
            anchor: new window.google.maps.Point(0, 0),
            strokeWeight: 0,
            scale: 0.3,
        };

        //private method definitions here
        const initializeModule = function ($self) {

            $self.map = new window.google.maps.Map($self.$mapElement[0], {
                zoom: $self.config.map_content.zoom,
                center: new window.google.maps.LatLng($self.config.map_content.center.lat, $self.config.map_content.center.lng),
                mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                disableDefaultUI: true,
                zoomControl: true,
                styles: [
                    {
                        'featureType': 'landscape',
                        'stylers': [
                            {
                                'color': '#ffffff',
                            },
                        ],
                    },
                    {
                        'featureType': 'water',
                        'stylers': [
                            {
                                'color': '#02083e',
                            },
                            {
                                'weight': 2.5,
                            },
                        ],
                    },
                ],
                //mapId: '716288ed381af272',
            });

            // Change marker size on zoom changed
            $self.map.addListener('zoom_changed', () => {
                // Change all markers size
                markers_list.forEach((marker) => {
                    marker.setIcon(getMarkerIcon($self.map.getZoom()));
                });
            });

            $self.config.map_content.markers.forEach(m => {
                let marker = new window.google.maps.Marker({
                    position: new window.google.maps.LatLng(m.lat, m.lng),
                    map: $self.map,
                    icon: getMarkerIcon(),
                });

                marker.postId = m.partner_id;
                // Open partner modal on click
                marker.addListener('click', function () {
                    partnerDataBio($self, m.partner_id);
                });

                markers_list.push(marker);
                $self.markers.push(marker);
            });
        }

        // Function to get markerIcon
        function getMarkerIcon(zoom = 2) {
            let markerScale = (0.3 + (((zoom - 2) / 10) * 5));

            if (markerScale < 0.3) {
                markerScale = 0.3;
            }
            else if (markerScale > 1.3) {
                markerScale = 1.3;
            }

            markerIcon.scale = markerScale;

            return markerIcon;
        }

        // Function to show partner modal
        function partnerDataBio($self, partnerId) {
            $self.$mapContainer.addClass('loading');

            $.frAjax({
                action: 'partnerBio',
                data: {
                    partnerId: partnerId,
                },
                onComplete: () => {
                    $self.$mapContainer.removeClass('loading');
                },
            })
                .then(data => {
                    $modalId.find('.modal-body').html(data);
                    $.frModalOpen($modalId);
                })
                .catch(err => {
                    console.error(err);
                });

            return this;
        }

        // Funaction for add class to body
        const addBodyClass = function () {

            // If page not contain any map block
            if($('.google-map-module-container').length === 0){
                return;
            }

            const $lastPageRow = $('.page-content-container .page-row').last();
            const $lastPageBlock = $($lastPageRow).find('.module').last();

            // If last block is map
            if($lastPageBlock && $($lastPageBlock).hasClass('google-map-module-container')){
                $('body').addClass('has-last-map-block');
            }
        }

        //for each matched elements
        this.each(() => {
            //do something
            const $self = this;
            $self.config = JSON.parse($self.attr('module-config'));
            $self.$mapContainer = $self.find('.map-container');
            $self.$mapElement = $self.find('.map-element');
            $self.map = {};
            $self.markers = [];

            initializeModule($self);

            return this;
        });

        // Add Body classes
        addBodyClass();
    }

    $(() => {
        $('.google-map-module-container').googleMapModule();
    });

})($);



// WEBPACK FOOTER //
// ./scripts/modules/blocks/google-map.js